var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import lazyLoad from '../core/helper/lazyLoad';
import { HTMLRenderer } from '../renderer/HTMLRenderer';
var EditableEditor = lazyLoad(function () { return import('./EditableEditor'); });
var Editor = function (_a) {
    var _b, _c;
    var readOnly = _a.readOnly, value = _a.value, onChange = _a.onChange, onChangeLang = _a.onChangeLang, passedLang = _a.lang, cellPlugins = _a.cellPlugins, cellSpacing = _a.cellSpacing, children = _a.children, options = __rest(_a, ["readOnly", "value", "onChange", "onChangeLang", "lang", "cellPlugins", "cellSpacing", "children"]);
    // mount the component always in readonly, to avoid problems with SSR
    var _d = __read(useState(true), 2), renderReadOnly = _d[0], setRenderReadOnly = _d[1];
    useEffect(function () {
        setRenderReadOnly(readOnly);
    }, [readOnly]);
    var lang = (_c = passedLang !== null && passedLang !== void 0 ? passedLang : (_b = options.languages) === null || _b === void 0 ? void 0 : _b[0].lang) !== null && _c !== void 0 ? _c : 'default';
    // FIXME: we need to extact these objects here. It would be best, if the props would already group these,
    // but thats currently not the case and would mean a breaking change
    var renderOptions = {
        cellPlugins: cellPlugins,
        cellSpacing: cellSpacing,
    };
    var callbacks = {
        onChange: onChange,
        onChangeLang: onChangeLang,
    };
    return renderReadOnly ? (React.createElement(HTMLRenderer, { value: value, cellPlugins: cellPlugins, lang: lang, cellSpacing: cellSpacing })) : (React.createElement(EditableEditor, { fallback: React.createElement(HTMLRenderer, { value: value, cellPlugins: cellPlugins, lang: lang, cellSpacing: cellSpacing }), value: value, lang: lang, options: options, renderOptions: renderOptions, callbacks: callbacks, children: children }));
};
export default Editor;
//# sourceMappingURL=Editor.js.map